<template>
  <donut-errors-base :code-chars="[4, 4]">
    <div class="t-lg m-tx1">Looks like we took you down a wrong path...</div>
  </donut-errors-base>
</template>
